module.exports = __webpack_public_path__ + "img/VERTIV-icon.005c3735.png";